import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065ea483"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "info artist" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "info column" }
const _hoisted_5 = { class: "list-item" }
const _hoisted_6 = { class: "list-item" }
const _hoisted_7 = { class: "list-item" }
const _hoisted_8 = {
  key: 0,
  class: "info column"
}
const _hoisted_9 = { class: "info column" }
const _hoisted_10 = {
  key: 1,
  class: "link disabled"
}
const _hoisted_11 = {
  key: 1,
  class: "arrows"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: 
          _ctx.artist?.image?.medium ||
          _ctx.artist?.image?.original ||
          require('@/assets/imgs/avatar.png')
        ,
          alt: _ctx.artist?.full_name || 'Artist'
        }, null, 8, _hoisted_3),
        _createElementVNode("h3", null, _toDisplayString(_ctx.artist?.full_name || 'Unknown Artist'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(" Artworks "),
          _createElementVNode("span", null, _toDisplayString(_ctx.artist?.artworks?.total || 0), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" Online "),
          _createElementVNode("span", null, _toDisplayString(_ctx.artist?.artworks?.live || 0), 1)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createTextVNode(" Pending "),
          _createElementVNode("span", null, _toDisplayString(_ctx.artist?.artworks?.pending || 0), 1)
        ])
      ]),
      (_ctx.draggable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              icon: "mdi-delete",
              style: {"color":"white","background-color":"black","padding":"1.3rem","cursor":"pointer"},
              onClick: _ctx.emitDeleteArtist
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.artist?.id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "link",
              to: `/artists/${_ctx.artist.id}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Edit Artist ")
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "Edit Artist"))
      ]),
      (_ctx.draggable && _ctx.role !== 'private_seller')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              icon: "mdi-arrow-up-bold",
              onClick: _ctx.moveUp
            }, null, 8, ["onClick"]),
            _createVNode(_component_v_icon, {
              icon: "mdi-arrow-down-bold",
              onClick: _ctx.moveDown
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_divider)
  ], 64))
}